import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { haptic } from '../../utils/fx'
import { PandaSign } from './PandaSign'

const PHRASES = ['PANDA_SAY_1', 'PANDA_SAY_2', 'PANDA_SAY_3', 'PANDA_SAY_4']

const c = 'panda-bubble'

export const PandaBubble = ({ message }: { message?: string }) => {
  const { t } = useTranslation()
  const [phrase, setPhrase] = useState<string | null>(null)
  const [pokes, setPokes] = useState(0)
  const timeout = useRef<number>()

  useEffect(() => () => window.clearTimeout(timeout.current), [])

  function poke() {
    haptic(12)
    setPokes((n) => n + 1)
    setPhrase(PHRASES[pokes % PHRASES.length])
    window.clearTimeout(timeout.current)
    timeout.current = window.setTimeout(() => setPhrase(null), 2600)
  }

  const text = phrase ? t(phrase) : message
  if (!text) return null

  return (
    <div className={c}>
      <button className={`${c}__btn`} onClick={poke} aria-label='panda'>
        <PandaSign size={76} signKey={text}>
          {text}
        </PandaSign>
      </button>
    </div>
  )
}
